import * as React from 'react';
import ShopifyProduct from '../../interface/ShopifyProduct';
import ProductColourVariation from '../../interface/ProductColourVariation';
import ProductForm from './ProductForm';
import { ProductSectionSettings } from '../../interface/ProductSectionSettings';
import FavouriteProductButton from '../Favourites/FavouriteProductButton';

export interface ProductDetailsProps {
    product: ShopifyProduct
    customFields?: any
    colourVariations: ProductColourVariation[]
    productSectionSettings: ProductSectionSettings;
    moneyFormat: string
    afterpayEnabled: boolean
}

export const ProductDetails = (props:ProductDetailsProps) => {
    const { product, moneyFormat, customFields, colourVariations, productSectionSettings, afterpayEnabled } = props;
    return (
        <>
            <div className="product__header">
                <h1 className="product__title h3">{ product.title }</h1>
                <FavouriteProductButton productHandle={ product.handle }/>
            </div>
            { customFields.short_description && customFields.short_description !== "" ? <div className="product__short-description" dangerouslySetInnerHTML={{
                    __html: customFields.short_description
                }}></div> : '' }
            <ProductForm
                afterpayEnabled={afterpayEnabled}
                product={ product }
                moneyFormat={ moneyFormat }
                colourVariations={colourVariations}
                productSectionSettings={productSectionSettings}
            />
        </>
    );
}
